import NonEditableMessage from './component';

export default NonEditableMessage;
